import React from 'react';
import axios from 'axios';
import { useEffect,useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import AffichageAncienMatch from './affichageAncienMatch';
import AffichageProchainMatch from './affichageProchainMatch';

function AffichageArbitrageCoach(props) {
    const [equipe, setEquipe] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [pasDispo, setPasDispo] = useState(false);
    const Navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_URL;




  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/arbitrage/affichage/${props.userData.user.donnée.results[0].id_equipe}`,
          {
            withCredentials: true 
          }
        );
        setEquipe(response.data);
        setError(null);
        setIsLoading(false);

      } catch (error) {
        if (error.response) {
            if (error.response.status === 404) {
                setPasDispo(true);
            } else {
                setError(error.response.data.message);
            }
        } else {
            setError(true);
        }
        setIsLoading(false);

      }
    };

    fetchData(); 
  }, [apiUrl, props]);
  

        if (isLoading) {
          return (
          <div className="centered-content">
            <img src="/img/logo.png" alt="Logo" className="centered-logo" />
            <br/>
            <span className="loader"></span>
          </div>
          
          );  
        }
        if(error){
            return (
                <>
                <div id="alert-message" className="alert4" >
                    <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
                </div>
              </>  
            )
        }

    return (
        <>
        {pasDispo && (
            <Modal show={pasDispo} onHide={() => Navigate('/coach/tableau-de-bord/arbitrage')}>
                    <Modal.Header closeButton>
                    <Modal.Title>Aucun match trouvé pour votre équipe</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <>Aucun match trouvé pour votre équipe.</>
                    </Modal.Body>
                    <Modal.Footer>
                    <Button variant="secondary"  onClick={() => Navigate('/coach/tableau-de-bord/arbitrage')} >
                        Quitter
                    </Button>
                    </Modal.Footer>
            </Modal>
        )}
        {equipe && (
            <>
                <Card className="bg-dark text-white" style={{borderRadius: "var(--bs-card-border-radius)"}}>
                    <Card.Img src="/img/candidature.jpg" alt="Card image" />
                    <Card.ImgOverlay>
                    </Card.ImgOverlay>
                </Card><br/>
                <div className="text-center mb-3">
                            <Card.Title><strong>Donner un avis sur les arbitres des anciens matchs</strong></Card.Title><br/>
                </div>
                <AffichageAncienMatch userData={props.userData} AncienMatch={equipe.AncienMatch} equipe={equipe}/>
                <div className="text-center mb-3">
                            <Card.Title><strong>Candidatures pour les prochains matchs</strong></Card.Title><br/>
                </div>
                <AffichageProchainMatch userData={props.userData} equipe={equipe}/>
            </>
        )}

        </>
  );
}

export default AffichageArbitrageCoach;